import Model from "../../core/model/Model";
import { TCourtCase } from "./CourtCase";

export interface TCasePhase {
  courtLevel: number;
  courtCaseNumber: string;
  sequenceId: number;
  courtCase: TCourtCase;
}

export interface ICasePhase extends TCasePhase {}

const CasePhase = Model((model: TCasePhase): ICasePhase => {
  const _value: TCasePhase = Object.assign({}, model);

  return {
    get courtLevel() {
      return _value.courtLevel;
    },
    set courtLevel(value) {
      _value.courtLevel = value;
    },
    get courtCaseNumber() {
      return _value.courtCaseNumber;
    },
    set courtCaseNumber(value) {
      _value.courtCaseNumber = value;
    },
    get sequenceId() {
      return _value.sequenceId;
    },
    set sequenceId(value) {
      _value.sequenceId = value;
    },
    get courtCase() {
      return _value.courtCase;
    },
    set courtCase(value) {
      _value.courtCase = value;
    }
  };
});

export default CasePhase;
